<template lang="pug">
  div
    footer-nav
    div(:class="$style.copyright") © 2020 QRAR
</template>
<script>
import FooterNav from '@/components/Layout/FooterNav.vue'

export default {
  components: {
    FooterNav,
  },
}
</script>
<style module>
  .nav {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .navItem {
    padding: 10px;
    & a {
      color: var(--gray);
    }
  }
  .copyright {
    font-size: 1.2rem;
    color: var(--gray);
    text-align: center;
  }
</style>
